import { useState, useEffect } from 'react';
import { Head } from '@inertiajs/react';
import Topbar from '@/Components/Layout/Topbar';
import SearchModal from '@/Components/Layout/SearchModal';

export default function AppLayout({ children, title }) {
    const [searchOpen, setSearchOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                e.preventDefault();
                setSearchOpen(true);
            }
            if (e.key === 'Escape') {
                setSearchOpen(false);
                setMobileMenuOpen(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    // Close mobile menu on route change
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [title]);

    return (
        <>
            <Head title={title} />

            <Topbar
                onSearchOpen={() => setSearchOpen(true)}
                mobileMenuOpen={mobileMenuOpen}
                onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
            />

            <main className="main-content">
                <div className="container-fluid">
                    {children}
                </div>
            </main>

            <SearchModal
                isOpen={searchOpen}
                onClose={() => setSearchOpen(false)}
            />
        </>
    );
}
